import makeApiCall from "../master/axiosIndex";

const RABillApis = {
  listRABill: (params: any) =>
    makeApiCall({
      url: "/ra-bill/list",
      method: "get",
      params,
    }),
  createRABill: (data: any) =>
    makeApiCall({
      url: "/ra-bill/create",
      method: "post",
      data,
    }),
  getRABillById: (raBillId: any) =>
    makeApiCall({
      url: `/ra-bill/id/${raBillId}`,
      method: "get",
    }),
};

export default RABillApis;
